import React, { createContext, useState, useContext, useCallback, useRef } from 'react';
import { Toast } from 'primereact/toast';

type NotificationType = 'success' | 'info' | 'warn' | 'error';

interface NotificationContextType {
  addNotification: (type: NotificationType, message: string) => void;
}

const NotificationContext = createContext<NotificationContextType | undefined>(undefined);

export const useNotification = () => {
  const context = useContext(NotificationContext);
  if (context === undefined) {
    throw new Error('useNotification must be used within a NotificationProvider');
  }
  return context;
};

export const NotificationProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const toast = useRef<Toast>(null);

  const addNotification = useCallback((type: NotificationType, message: string) => {
    toast.current?.show({
      severity: type,
      summary: type.charAt(0).toUpperCase() + type.slice(1),
      detail: message,
      life: 3000
    });
  }, []);

  return (
    <NotificationContext.Provider value={{ addNotification }}>
      {children}
      <Toast ref={toast} />
    </NotificationContext.Provider>
  );
};

export default NotificationContext;